<template> 
  <div class="mx-5 my-5">
    <v-card>
      <v-card-title>
        <v-text-field v-model="search" append-icon="mdi-magnify" color="light-blue-darken-4"  label="Buscar" single-line hide-details></v-text-field>
      </v-card-title>
      <v-data-table :headers="headers" :items="registros" :search="search"></v-data-table>
    </v-card>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import suboficialae from "@/services/suboficialae";
import { VDataTable } from 'vuetify/labs/VDataTable'
export default defineComponent({
name: 'AdminPage',
components: {
  VDataTable
},
data() {
  var registros;
  const personal = new suboficialae();
  return {
    registros,
    personal,
    search: '',
    headers: [
      {
        align: 'center',
        key: 'name',
        sortable: true,

      },
      { key: 'cod_personal', title: 'Codigo Personal' },
      { key: 'descripcion', title: 'Grado' },
      { key: 'nombres', title: 'Nombres' },
      { key: 'apellido_paterno', title: 'Apellido Paterno' },
      { key: 'apellido_materno', title: 'Apellido Materno' },
      // {
      //   key: 'nombre',
      //   title: 'Nombre Completo',
      //   value: (item) => `${item.nombres} ${item.apellido_paterno} ${item.apellido_materno}`, // Concatenación de nombres y apellido paterno
      // },
    ],

  }
},
methods: {

},

async created() {
  this.registros = await this.personal.index();
}
});
</script>